import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import { Role } from './useValidateSession';

export interface InviteResponse {
    locationId: Array<string> | 'all';
    locationName: string;
    position: Role;
    email: string;
    organizationId: string;
    /** Yaxle employee invite (from Settings → Yaxle → Team). */
    internal?: boolean;
    /** Employee invites: the name the team manager entered. */
    firstName?: string;
    lastName?: string;
}

const getInvite = async (inviteId: string): Promise<InviteResponse> => {
    const { data } = await axios.get(`${API_URL}/settings/user/invite`, {
        params: { inviteId }
    });
    return data;
};

export const useGetInvite = (inviteId: string | undefined) => {
    return useQuery({
        queryKey: ['invite', inviteId],
        queryFn: () => getInvite(inviteId!),
        enabled: !!inviteId,
        retry: false
    });
};

